export default __webpack_public_path__ + "static/media/demo5.7fb53779.png";